"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Slider: ()=>Slider
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const slider_namespaceObject = require("@base-ui-components/react/slider");
const external_react_namespaceObject = require("react");
const external_Slider_variants_cjs_namespaceObject = require("./Slider.variants.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_SliderMark_cjs_namespaceObject = require("./SliderMark.cjs");
function Slider({ labelText = '', showValueText = false, emphasis = 'regular', name = '', ariaLabelledby = '', disabled, step = 1, min = 0, max = 100, value, defaultValue, handleChange, currencyHelperText = '', currencySymbol = '', valueSuffix = '', marks = [], slotClassNames = {} }) {
    const { root, label, valueText, control, track, indicator, thumb, marks: marksSlot } = (0, external_Slider_variants_cjs_namespaceObject.sliderVariants)({
        emphasis
    });
    const { rootClass = '', labelClass = '', valueTextClass = '', indicatorClass = '', controlClass = '', trackClass = '', thumbClass = '', marksClass = '' } = slotClassNames;
    const v = value || defaultValue;
    const rootClasses = (0, cn_cjs_namespaceObject.cn)(root(), rootClass);
    const labelClasses = (0, cn_cjs_namespaceObject.cn)(label(), labelClass);
    const valueTextClasses = (0, cn_cjs_namespaceObject.cn)(valueText(), valueTextClass);
    const controlClasses = (0, cn_cjs_namespaceObject.cn)(control(), controlClass);
    const trackClasses = (0, cn_cjs_namespaceObject.cn)(track(), trackClass);
    const indicatorClasses = (0, cn_cjs_namespaceObject.cn)(indicator(), indicatorClass);
    const thumbClasses = (0, cn_cjs_namespaceObject.cn)(thumb(), thumbClass);
    const marksClasses = (0, cn_cjs_namespaceObject.cn)(marksSlot(), marksClass);
    const markPositions = (0, external_react_namespaceObject.useMemo)(()=>marks.map((mark)=>({
                ...mark,
                value: mark.value / max * 100
            })), [
        marks,
        max
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(slider_namespaceObject.Slider.Root, {
        className: rootClasses,
        "data-testid": "root",
        name: name,
        "aria-labelledby": ariaLabelledby,
        defaultValue: defaultValue,
        disabled: disabled,
        step: step,
        min: min,
        max: max,
        value: value,
        onValueChange: handleChange,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: "flex h-5 justify-between",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        "data-testid": "label",
                        className: labelClasses,
                        children: labelText
                    }),
                    showValueText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        "data-testid": "value",
                        className: valueTextClasses,
                        children: [
                            currencyHelperText,
                            " ",
                            currencySymbol,
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(slider_namespaceObject.Slider.Value, {}),
                            valueSuffix
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(slider_namespaceObject.Slider.Control, {
                "data-testid": "control",
                className: controlClasses,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(slider_namespaceObject.Slider.Track, {
                    "data-testid": "track",
                    className: trackClasses,
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(slider_namespaceObject.Slider.Indicator, {
                            "data-testid": "indicator",
                            className: indicatorClasses
                        }),
                        marks?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: marksClasses,
                            "data-testid": "marks",
                            children: markPositions.map((mark)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_SliderMark_cjs_namespaceObject.SliderMark, {
                                    label: mark.label,
                                    value: mark.value
                                }, `mark-${mark.label}`))
                        }),
                        v && Array.isArray(v) ? v.map((item)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(slider_namespaceObject.Slider.Thumb, {
                                className: thumbClasses
                            }, `thumb-${item}`)) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(slider_namespaceObject.Slider.Thumb, {
                            className: thumbClasses
                        })
                    ]
                })
            })
        ]
    });
}
exports.Slider = __webpack_exports__.Slider;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Slider"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
